<template>
  <layout-workflow>
    <v-layout column align-center mt-4>
      <v-flex data-e2e-id="not-found">
        <h2 class="mt-4">Page Not Found</h2>
        <p class="subheading">
          The page navigated to was not found.
        </p>
      </v-flex>
    </v-layout>
  </layout-workflow>
</template>

<script>
import LayoutWorkflow from '@/components/layout/LayoutWorkflow'

export default {
  components: { LayoutWorkflow }
}
</script>
